<template>
    <div>
        <section
            v-if="page.content"
            class="l-section l-section--hero"
        >
            <h1
                class="l-section__title | t-t1-serif"
                v-html="page.content.header_title"
            ></h1>

            <ul
                v-if="featuredProducts.length > 0"
                class="o-highlight"
            >

                <li
                    v-for="(product, i) in featuredProducts"
                    :key="`product-${product.ueatId}`"
                    class="o-highlight__item"
                    v-parallax="i === 0 ? -.2 : .4"
                >
                    <span v-if="product.title" class="o-highlight__box">
                        <a
                            :href="`/fr/commande-en-ligne/#/?service=takeout&showItem=${product.ueatId}`"
                            :title="product.title"
                            class="o-highlight__link"
                        >
                            <span v-if="i == 0" class="o-shape-circle | bg-red"></span>
                            <span v-if="i == 0" class="o-shape-rect | bg-primaryLight | --rot135"></span>

                            <span  class="o-highlight__fig">
                                <asset
                                    v-if="product.cover && product.cover.icon"
                                    :src="product.cover.filename|resources('images')"
                                    :srcset="product.cover.icon.cards.srcset"
                                    :webpAuto="true"
                                    class="o-highlight__img"
                                >
                                </asset>
                            </span>

                            <img v-if="i == 1" src="~assets/img/layout/deco/rain.png" alt="Decoration" class="o-highlight__deco">
                        </a>
                        <Btn
                            tag="span"
                            class="c-btn--filled-light | o-highlight__price"
                        >
                            <strong>{{ product.displayPrice|price }}</strong>
                        </Btn>
                        <Tooltip v-if="product.category" class="o-highlight__tooltip">
                            <div class="flex items-center justify-between md:justify-center">
                                <strong class="md:hidden pr-4">{{ product.displayPrice|price }}</strong>
                                <Btn
                                    tag="span"
                                    :label="product.category.title"
                                    class="c-btn--rounded"
                                />
                            </div>
                            <h3 class="t-t3 | mt-4">{{ product.title }}</h3>
                        </Tooltip>
                    </span>
                </li>

            </ul>
            <div class="l-section__content">
                <ul class="o-icon-list">
                    <li
                        v-for="item in page.content.advantages"
                        :key="item.index"
                        class="o-icon-list__item"
                    >

                        <span
                            v-if="item.icon && item.icon[0]"
                            class="o-icon-list__icon"
                        >
                            <asset :src="item.icon[0].filename|resources('illustrations')"></asset>
                        </span>

                        <span class="o-icon-list__content">
                            <span class="t-s">{{ item.description }}</span>
                        </span>
                    </li>
                </ul>
            </div>
        </section>

        <section class="l-section">

            <ThumbList
                v-if="featuredCategories && featuredCategories.length"
                :categories="featuredCategories"
                :slider="true"
                :limit="4"
            />
        </section>

        <section class="l-section">
            <div class="l-grid">
                <div class="l-grid__row --items-center --justify-center">
                    <div class="w-full xxs:w-full xs:w-5/6 sm:w-1/2 | --no-gutter@sm-max">

                        <div
                            v-if="page.content.partners_image[0]"
                            class="o-composition-container--rounded"
                        >
                            <asset
                                :src="page.content.partners_image[0].filename|resources('images')"
                                :srcset="page.content.partners_image[0].icon.cards.srcset"
                                class="u-img"
                            >
                            </asset>
                            <span class="o-shape-circle | bg-red | --r0@xs-max --r-5@sm-max --r-10@sm | --t-10">
<!--                                 <Icon icon="colibri-cie" class="text-beige" /> -->
                            </span>
                            <img src="~assets/img/layout/deco/rain.png" alt="Decoration" class="o-deco | u-img | --b-10 --l-10 --w45" v-parallax="-.6">
                            <span class="o-shape-circle | bg-blue | --l5 --l15@sm | --b-10" v-parallax=".2"></span>
                        </div>

                    </div>

                    <div class="w-full xxs:w-5/6 xs:w-3/4 sm:w-1/2 | self-auto sm:self-center">

                        <div class="l-section__container | py-20 sm:py-30 md:py-4">

                            <h2 class="l-section__title | t-t1-serif">
                                {{ page.content.partners_title }}
                            </h2>
                            <Btn
                                tag="router-link"
                                to="/fr/mission"
                                label="Découvrez pourquoi"
                                class="c-btn--filled"
                            />

                        </div>

                    </div>
                </div>
            </div>
        </section>
        <Instagram />
    </div>
</template>

<script>/* eslint-disable */

    import Asset from 'components/Asset'
    import Btn from 'components/Btn'
    import ThumbList from 'components/ThumbList'
    import Instagram from 'components/Instagram'
    import Icon from 'components/Icon'
    import Tooltip from 'components/Tooltip'

    import { mapGetters } from 'vuex'
    import merge from 'lodash/merge'

    export default {
        name: 'Home',
        components: {
            Asset,
            Btn,
            ThumbList,
            Instagram,
            Icon,
            Tooltip
        },
        props: {
            page: Object,
            site: Object
        },
        metaInfo() {

            if ( !this.site || !this.site.settings || !this.page )
                return {}

            return {
                title: (this.page.content.seo_title || this.site.settings.site_tagline || this.page.content.title),
                description: this.page.content.seo_description,
                titleTemplate: this.site.settings.site_name + ' — %s',
            }
        },
        computed: {

            ...mapGetters('ueat', ['getItemById', 'getCategoryById', 'getCategoryItems']),

            featuredProducts() {

                if ( !this.page.content )
                    return

                if ( !this.page.content.featured_products )
                    return

                const _ = this
                const _featured_products = this.page.content.featured_products.filter(p => p.product != "")

                return _featured_products.map(p => (

                    merge({}, _.getItemById(p.product), {
                        cover: (p.custom_thumbnail[0]) ? p.custom_thumbnail[0] : p.product.cover
                    })

                ))

            },
            featuredCategories() {

                if ( !this.page.content )
                    return null

                if ( !this.page.content.featured_categories )
                    return null

                if ( this.$store.state.ueat.categories.length === 0 )
                    return null

                const _ = this
                let _featured_categories = this.page.content.featured_categories;

                _featured_categories = _featured_categories.map(entry => _.getCategoryById(entry.category))

                return _featured_categories.filter(c => c != null);

            }
        }
    }
</script>

<style>
</style>
